import React from "react";
import { motion } from "framer-motion";
import { ASSETS } from "../data/menu";

const tiles = [
  { src: ASSETS.hero, span: "lg:row-span-2", alt: "OROMA coffee cup with croissant" },
  { src: ASSETS.interior, span: "", alt: "OROMA café interior with warm pendant lights" },
  { src: ASSETS.cookies, span: "lg:row-span-2", alt: "Stack of OROMA-branded cookies" },
  { src: ASSETS.pendant, span: "", alt: "Pendant lamp with oroma wall script" },
  { src: ASSETS.interior, span: "", alt: "Espresso bar at OROMA" },
  { src: ASSETS.hero, span: "", alt: "Coffee and croissant ritual" },
  { src: ASSETS.cookies, span: "", alt: "Cookies up close" },
  { src: ASSETS.pendant, span: "", alt: "Warm light, warm room" },
];

export const Gallery = () => {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative bg-cream py-24 md:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <span className="inline-flex items-center gap-3 text-espresso/60 text-[12px] tracking-[0.3em] uppercase mb-5">
              <span className="h-px w-10 bg-espresso/40" />
              Moments
            </span>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-espresso text-balance">
              A walk through <span className="italic">our room.</span>
            </h2>
          </div>
          <a
            href="https://www.instagram.com/oroma_bombay"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="gallery-instagram-link"
            className="link-underline text-[12px] tracking-[0.28em] uppercase text-espresso"
          >
            @oroma_bombay →
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 auto-rows-[180px] md:auto-rows-[220px] lg:auto-rows-[240px] gap-3 md:gap-4">
          {tiles.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.05 }}
              className={`zoom-wrap relative ${t.span} overflow-hidden group`}
              data-testid={`gallery-tile-${i}`}
            >
              <img
                src={t.src}
                alt={t.alt}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-espresso/0 group-hover:bg-espresso/20 transition-colors duration-500" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
